export const categories = [
  {
    name: "All",
    id: "all",
  },
  {
    name: "Science",
    id: "science",
  },
  {
    name: "Business",
    id: "business",
  },
  {
    name: "National",
    id: "national",
  },
  {
    name: "Sports",
    id: "sports",
  },
  {
    name: "World",
    id: "world",
  },
  {
    name: "Technology",
    id: "technology",
  },
  {
    name: "Startup",
    id: "startup",
  },
  {
    name: "Entertainment",
    id: "entertainment",
  },
  {
    name: "Politics",
    id: "politics",
  },
  {
    name: "Miscellaneous",
    id: "miscellaneous",
  },
];
